<template>
  <div :class="['activity-bar',isMobile ? ' ':'mobile-style',]" v-if="barList">
    <div class="one_guild" v-if="barList.length == 1 && barList[0].icon ">
      <!-- <img src="../../assets/img/activity/1.png" alt="" /> -->
      <img @click="jumpLink(barList[0])" :src="barList[0].icon" alt="" />
    </div>
    <div v-else>
      <div
        :class="[
          currentScrolling == 2
            ? 'bar-close-come'
            : currentScrolling == 3
            ? 'bar-close-leave'
            : '',
        ]"
        v-show="currentScrolling != 1 && barList.length > 1"
      >
        <div class="footer-bar-right">
          <!-- ！！！不要删除这个空的div ,小米9样式不兼容,加个空的div 让右边的div flex弹性布局居于最右侧 -->
          <div></div>
          <div class="footer-bar-right-item"
          :style="{ boxShadow: `0px 0px 10px 0px ${boxShadowColor()}`,
          color: barListCur[0]?.textColor, 
          fontWeight:`${ barListCur[0]?.textBold ? 'bold' : 'normal'}` }" >
            <div class="more-icon">
              <more-svg :color="barListCur[0]?.textColor || '#5B1700'" />
            </div>
          更多专区
          </div>
        </div>
      </div>
      <div
        :class="[
          'tab-container',
          currentScrolling == 3
            ? 'bar-open-come'
            : currentScrolling == 2
            ? 'bar-open-leave'
            : '',
        ]"
      >
        <div
          class="tab-box"
           :style="{ boxShadow: `0px 0px 10px 0px ${boxShadowColor()}`}"
        >
          <div ref="tabRef" class="tab">
            <div
              v-for="(guide, item) in barListCur"
              :key="item"
              class="tab-item"
              @click="goAct(guide,item)"
            >
              <span class="item" :style="{ color: barActive == item ? guide.ActiveColor || '#FF4410' : guide.textColor || '#5B1700', fontWeight:`${ guide?.textBold ? 'bold' : 'normal'}` }">
                <span class="item-text" :style="{borderRight: `1px solid ${item < 4 && item == barList.length-1  ? 'transparent':'rgba(153, 153, 153, 0.5)'}`}">
                  {{ guide.text }}
                </span>
              </span>
              <span class="new-tip" v-if="guide.bubbleTip"> {{ guide.bubbleTip }}</span>
            </div>
            <div
              class="more"
              @click="showMore = true"
              v-show="barList.length > 5"
            >
              <more-svg :color="barListCur[0]?.textColor || '#5B1700'" class="more-icon" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="showMore">
      <div class="more_bar">
        <div class="more_bar_title">
          <div class="all_bar">全部专场</div>
          <img
            src="@/assets/img/activity/activity-bar/close_icon.png"
            alt=""
            @click="showMore = false"
          />
        </div>
        <div class="more_bar_wrap">
          <div
            class="more_bar_item"
            v-for="(guide, index) in barList"
            :key="index"
            @click="goAct(guide, index)"
          >
            <div :class="[{'bar_active': barActive == index },'bar_item' ]">
              <div class="bar_name">{{ guide.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import { ActionSheet } from "vant";
import MoreSvg  from "./MoreSvg.vue";
export default {
  name: "ActivityBar",
  components: {
    [ActionSheet.name]: ActionSheet,
    MoreSvg
  },
  props: {
    dataSources: {
      type: String,
      default: "",
    },
    customGuideList: {
      type: Array,
      default: () => [],
    },
    isScrolling: {
      type: Number,
      default: 1, // 无动画效果
    },
    sensors: {
      // 埋点对象，必填
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    buttonColor: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showMore: false,
      barActive: -1,
      currentScrolling: 1,
    };
  },
  watch: {
    barList: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.sensors.track("WidgetShow", {
            $element_id: "sensor_bcop_guide",
            contentType: "自定义引导",
          });
        }
      },
    },
    showMore: {
      immediate: true,
      handler: function handler(newVal) {
        if (newVal) {
          this.sensors.track("$WebClick", {
            $element_id: "sensor_bcop_viewmore",
            contentType: "自定义引导",
          });
        }
      },
    },
    isScrolling(newVal) {
      this.currentScrolling = newVal;
      console.log('====currentScrolling',newVal)
    },
  },
  computed: {
    barList() {
      if (this.customGuideList && this.customGuideList.length > 0) {
        return this.customGuideList;
      } else {
        return null;
      }
    },
    barListCur() {
      if (this.barList.length > 5) {
        return this.barList.slice(0, 4);
      } else {
        return this.barList.slice(0, 5);
      }
    },
    isMobile() {
      return ["51jobM", "yjsM"].includes(this.platform)
    },
    platform() {
      return this.$store.getters.platform;
    },
  },
  mounted() {},
  methods: {
    goAct(guide, index) {
      this.barActive = index;
      this.jumpLink(guide);
    },
    jumpLink(guide) {
      this.$emit("jumpLink", guide);
    },
    boxShadowColor(){
      const hex = this.buttonColor
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      let color = null
      if (result) {  
        const r= parseInt(result[1], 16);
        const g= parseInt(result[2], 16);
        const b= parseInt(result[3], 16); 
          color = `rgba(${r},${g},${b}, ${0.3})`
      } 
      return  color || `rgba(162, 71, 255, 0.3)`;
    }
    // async activityJumpLink(){
    //   const res = await this.cupid.post(
    //     "/open/noauth/bcop-activity/activityPageInfoQuery",
    //     { pageId: this.sourceIdVal,
    //       isPreview: !!this.$route.query.preview,
    //     }
    //   );
    //   if (res?.code == "0" && res?.data) {
    //     this.barList = res.data.customGuideList
    //     // this.barList = []
    //     this.$emit('getCustomGuideList', this.barList)
    //   }
    // }
  },
};
</script>

<style lang="less" scoped>
.activity-bar {
  .one_guild {
    position: fixed;
    bottom: 10px;
    width: 100%;   
    border-radius: 14px;
    box-shadow: 0px 1px 2px 0px rgba(84, 57, 28, 0.26);
    overflow: hidden;
    img {
      width: 100%;
      display: block;
      height: 46px;
      .pc & {
        max-width: 375px;
      }
    }
  }
  .more_bar {
    padding: 16px 10px 0;
    &_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 0 16px 6px;
      img {
        width: 16px;
        height: 15.75px;
      }
    }
    .all_bar {
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
      height: 17px;
      letter-spacing: 0px;
      color: #222222;
    }
    .more_bar_wrap {
      // display: flex;
      // gap:3.5%;
      // flex-wrap: wrap;
      max-height: 50vh;
      overflow-y: auto;
      margin-bottom: 12px;
    }
    .more_bar_item {
      width: 33.3%;
      display: inline-block;
    }
    .bar_item {
      border-radius: 21px;
      opacity: 1;
      background: #f2f4f7;
      padding: 12px 10px;
      margin-bottom: 12px;
      margin: 0 6px 12px 6px;
      .bar_name {
        max-width: 72px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: normal;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0px;
        color: #222222;
        margin: 0 auto;
      }
    }

    .bar_active {
      background: linear-gradient(180deg, #ffb245 1%, #ff4e0e 99%);
      .bar_name {
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        text-align: center;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }

  .footer-bar-right {
    margin-right: -56px;

  &-item {
    opacity: 1;
    // margin-right: 6px;
    background: linear-gradient(90deg, #FFF281 7%, #FFD560 99%), linear-gradient(90deg, #FFEE5E 1%, #FFCE46 99%);
    box-sizing: border-box;
    border: 1px solid #FFFFFF;
    backdrop-filter: blur(14px);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    padding-left: 15px;
    height: 36px;
    line-height: 36px;
    width: 115px;
    box-sizing: border-box;
    font-size: 13px;
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    color: #5B1700;
    .more-icon {
      margin-top: 8px;
      margin-right: 4px;
    }
  }
}
  .tab-container {
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 6px 12px 6px;
    .adapt_pc_widescreen & {
      width: 375px;
    }
    .tab-box {
      border-radius: 18px;
      background: linear-gradient(90deg, #fff281 3%, #ffd560 99%);
      border: 1px solid #ffffff;
      backdrop-filter: blur(14px);

      .tab {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: nowrap;
        padding-top: 6px;
        padding-bottom: 8px;
        height: 36px;
        width: 100%;
        box-sizing: border-box;
        font-family: PingFangSC, PingFang SC;

        &-item {
          // padding: 10px 0;
          // width: 77.5px;
          text-align: center;
          height: 36px;
          position: relative;
          font-size: 12px;
          width: 100%;

          .item {
            display: inline-block;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            white-space: nowrap;
            cursor: pointer;
            font-size: 13px;
            color: #5b1700;
            font-weight: 500;
            display: flex;
            justify-content: center;
            align-items: center;

            &-text {
              display: inline-block;
              width: 100%;
              height: 60%;
              display: flex;
              justify-content: center;
              align-items: center;
              // border-right: 1px solid rgba(153, 153, 153, 0.5);
            }
          }

          .new-tip {
            display: inline-block;
            padding: 0 5px;
            height: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(270deg, #ff6314 0%, #ff3314 100%);
            border-radius: 8px 8px 8px 0;
            position: absolute;
            right: 4px;
            top: -6px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
          }
        }

        &-item:first-child {
          padding-left: 10px;
          border-top-left-radius: 20px;
          border-bottom-left-radius: 20px;
        }

        .more {
          height: 36px;
          line-height: 36px;
          padding: 2px 16px 0px 16px;
          flex: none;
          border-top-right-radius: 20px;
          border-bottom-right-radius: 20px;
          // float: right;

          .arrow {
            width: 4px;
            height: 3px;
          }

          .more-icon {
            width: 19px;
            height: 20px;
          }
        }
      }
    }
  }
}
.mobile-style  {
  .tab-container {
    max-width: 375px;
    margin: auto;
  }
}
// 动画
.bar-open-come {
  animation: bar-open-come 0.3s ease-out forwards;
  transform: translateY(-50%);
}
.bar-open-leave {
  animation: bar-open-leave 0.1s ease-out forwards;
  transform: translateY(-50%);
}
.bar-close-come {
  position: fixed;
  z-index: 999;
  right: 46px;
  bottom: 10px;
  animation: bar-close-come 0.3s ease-out forwards;
  transform: translateY(0%);
}
.bar-close-leave {
  position: fixed;
  z-index: 999;
  right: -70px;
  bottom: 10px;
  // animation: bar-close-leave 0.1s ease-out forwards;
  transform: translateY(0%);
}
@keyframes bar-open-come {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes bar-open-leave {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(0);
    opacity: 0;
  }
}

@keyframes bar-close-come {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes bar-close-leave {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(0%);
    opacity: 0;
  }
}
// 底部bar样式
.activity-bar {
  .van-popup {
    top: auto !important;
  }
  .van-popup--bottom {
    width: 100% !important;
    .pc & {
      width: 375px !important;
    }
  }
}
</style>
